/*
 *
 * Chat constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
import disappointingEmoji from 'ui/components/RatingCard/EmojiIcons/disappointingEmoji.svg';
import badEmoji from 'ui/components/RatingCard/EmojiIcons/badEmoji.svg';
import justokEmoji from 'ui/components/RatingCard/EmojiIcons/justokEmoji.svg';
import goodEmoji from 'ui/components/RatingCard/EmojiIcons/goodEmoji.svg';
import excellentEmoji from 'ui/components/RatingCard/EmojiIcons/excellentEmoji.svg';

const prefix = 'ui/containers/Chat';
// For inbox detail
export const GET_INBOX_DETAIL = defineApiActionTypes(`${prefix}/GET_INBOX_DETAIL`);
export const SET_CONVERSATION_REQUEST = defineApiActionTypes(`${prefix}/SET_CONVERSATION_REQUEST`);
export const UPDATE_INBOX_STATISTICS = defineApiActionTypes(`${prefix}/UPDATE_INBOX_STATISTICS`);
// For conversation list
export const GET_CONVERSATION_LIST = defineApiActionTypes(`${prefix}/GET_CONVERSATION_LIST`);
export const GET_CONVERSATION_LIST_FILTERED = defineApiActionTypes(
  `${prefix}/GET_CONVERSATION_LIST_FILTERED`
);
export const CLOSE_SELECTED_CONVERSATION = defineApiActionTypes(
  `${prefix}/CLOSE_SELECTED_CONVERSATION`
);
export const REMOVE_CONVERSATION_DETAIL = `${prefix}/REMOVE_CONVERSATION_DETAIL`;
export const GET_TEAM_MEMBERS = defineApiActionTypes(`${prefix}/GET_TEAM_MEMBERS`);
export const GET_CONVERSATION_MEMBERS = defineApiActionTypes(`${prefix}/GET_CONVERSATION_MEMBERS`);
export const UPDATE_CONVERSATIONS_READ = defineApiActionTypes(
  `${prefix}/UPDATE_CONVERSATIONS_READ`
);
export const UPDATE_SELECTED_FILTERS = defineApiActionTypes(`${prefix}/UPDATE_SELECTED_FILTERS`);
// For conversation detail
export const GET_CONVERSATION_DETAIL = defineApiActionTypes(`${prefix}/GET_CONVERSATION_DETAIL`);
export const GET_CONVERSATION_FROM_PARAMS = defineApiActionTypes(
  `${prefix}/GET_CONVERSATION_FROM_PARAMS`
);
export const LOADING_NEW_CONVERSATION = `${prefix}/LOADING_NEW_CONVERSATION`;
// For send message
export const SEND_CONVERSATION_MESSAGES = defineApiActionTypes(
  `${prefix}/SEND_CONVERSATION_MESSAGES`
);
export const UPDATE_CONVERSATION_MESSAGES = defineApiActionTypes(
  `${prefix}/UPDATE_CONVERSATION_MESSAGES`
);
export const START_BOOK_MEETING = defineApiActionTypes(`${prefix}/START_BOOK_MEETING`);
export const SET_ARCHIVE_STAR_CONVERSATION = defineApiActionTypes(
  `${prefix}/SET_ARCHIVE_STAR_CONVERSATION`
);
export const UPDATE_CONVERSATION_LIST = `${prefix}/UPDATE_CONVERSATION_LIST`;
export const UPDATE_INBOX_DETAIL_STATISTICS = `${prefix}/UPDATE_INBOX_DETAIL_STATISTICS`;
export const ADD_NEW_MEMBER_CONVERSATION = defineApiActionTypes(
  `${prefix}/ADD_NEW_MEMBER_CONVERSATION`
);
export const REMOVE_MEMBER_CONVERSATION = defineApiActionTypes(
  `${prefix}/REMOVE_MEMBER_CONVERSATION`
);
export const READ_CONVERSATION = defineApiActionTypes(`${prefix}/READ_CONVERSATION`);

export const UPDATE_CONVERSATION_STATUS = defineApiActionTypes(
  `${prefix}/UPDATE_CONVERSATION_STATUS`
);
export const UPDATE_INBOX_DATA = `${prefix}/UPDATE_INBOX_DATA`;
export const CHANGE_CURRENT_CONVERSATION = `${prefix}/CHANGE_CURRENT_CONVERSATION`;
export const GET_USER_STATUS = defineApiActionTypes(`${prefix}/GET_USER_STATUS`);
export const UPDATE_USER_STATUS = defineApiActionTypes(`${prefix}/UPDATE_USER_STATUS`);
export const ADD_TO_CONVERSATIONS_LIST = `${prefix}/ADD_TO_CONVERSATIONS_LIST`;
export const REMOVE_FROM_CONVERSATIONS_LIST = `${prefix}/REMOVE_FROM_CONVERSATIONS_LIST`;
export const UPDATE_SENDING_MESSAGES = `${prefix}/UPDATE_SENDING_MESSAGES`;
export const HANDLE_SENDING_MESSAGE_TO_PUSHER = `${prefix}/HANDLE_SENDING_MESSAGE_TO_PUSHER`;
export const REMOVE_FROM_SENDING_MESSAGES = `${prefix}/REMOVE_FROM_SENDING_MESSAGES`;
export const UPDATE_MESSAGE_READ_STATUS = `${prefix}/UPDATE_MESSAGE_READ_STATUS`;
export const UPDATE_MESSAGE_DELIVERED = `${prefix}/UPDATE_MESSAGE_DELIVERED`;
export const IS_UPDATE_CONVERSATION_LISTS = `${prefix}/IS_UPDATE_CONVERSATION_LISTS`;
export const UPDATE_CONVERSATION_DETAILS = `${prefix}/UPDATE_CONVERSATION_DETAILS`;
export const GET_CANNED_MESSAGES = defineApiActionTypes(`${prefix}/GET_CANNED_MESSAGES`);
export const SAVE_CANNED_MESSAGE = defineApiActionTypes(`${prefix}/SAVE_CANNED_MESSAGE`);
export const SET_CUSTOM_FILTER = `${prefix}/SET_CUSTOM_FILTER`;
export const DELETE_CANNED_MESSAGE = defineApiActionTypes(`${prefix}/DELETE_CANNED_MESSAGE`);
export const POLL_BACKEND = `${prefix}/POLL_BACKEND`;
export const EDITOR_HAS_CONTENT = `${prefix}/EDITOR_HAS_CONTENT`;
export const HAS_NEW_MESSAGES = `${prefix}/HAS_NEW_MESSAGES`;
export const HAS_SEND_MESSAGE = defineApiActionTypes(`${prefix}/HAS_SEND_MESSAGE`);
export const SEND_MESSAGE = `${prefix}/SEND_MESSAGES`;
export const CREATE_ZENDESK_TICKET = defineApiActionTypes(`${prefix}/CREATE_ZENDESK_TICKET`);
export const GET_KNOWLEDGE_BASE_ARTICLES = defineApiActionTypes(
  `${prefix}/GET_KNOWLEDGE_BASE_ARTICLES`
);
export const CHANGE_ZENDESK_INBOX_ACTIVE_TAB = 'CHANGE_ZENDESK_INBOX_ACTIVE_TAB';
export const GET_CONNECTED_APPS = defineApiActionTypes(`${prefix}/GET_CONNECTED_APPS`);
export const LOGOUT_USER = defineApiActionTypes(`${prefix}/LOGOUT_USER`);
export const CREATE_SERVICE_CLOUD_CASE = defineApiActionTypes(
  `${prefix}/CREATE_SERVICE_CLOUD_CASE`
);
export const GET_SERVICE_CLOUD_ARTICLES = defineApiActionTypes(
  `${prefix}/GET_SERVICE_CLOUD_ARTICLES`
);
export const CHANGE_SERVICE_CLOUD_ACTIVE_TAB = `${prefix}/CHANGE_SERVICE_CLOUD_ACTIVE_TAB`;
export const BLOCK_VISITOR = defineApiActionTypes(`${prefix}/BLOCK_VISITOR`);
export const OPEN_VISITOR_BLOCK_MODAL = `${prefix}/OPEN_VISITOR_BLOCK_MODAL`;
export const GET_TAGS = defineApiActionTypes(`${prefix}/GET_TAGS`);
export const GET_SUBSCRIPTION_DETAILS = defineApiActionTypes(`${prefix}/GET_SUBSCRIPTION_DETAILS`);
export const GET_HIGHLIGHTS_FIELDS = defineApiActionTypes(`${prefix}/GET_HIGHLIGHTS_FIELDS`);
export const GET_HIGHLIGHTS_TEMPLATES = defineApiActionTypes(`${prefix}/GET_HIGHLIGHTS_TEMPLATES`);
export const SAVE_HIGHLIGHTS_BUILDER = defineApiActionTypes(`${prefix}/SAVE_HIGHLIGHTS_BUILDER`);
export const UPDATE_SELECTED_FIELDS_COUNT = `${prefix}/UPDATE_SELECTED_FIELDS_COUNT`;
export const UPDATE_CONVERSATION_LIST_FILTERS = `${prefix}/UPDATE_CONVERSATION_LIST_FILTERS`;

export const GET_ATTACHMENTS = defineApiActionTypes(`${prefix}/GET_ATTACHMENTS`);
export const UPDATE_ATTACHMENTS = `${prefix}/UPDATE_ATTACHMENTS`;
export const UPDATE_UPLOAD_PROGRESS = defineApiActionTypes(`${prefix}/UPDATE_UPLOAD_PROGRESS`);

export const PUSHER_EVENT_TYPES = {
  VISITOR_STATUS_CHANGE: 'visitor-status-change',
  NEW_MESSAGE: 'new-message',
  CONVERSATION_STATUS_CHANGE: 'conversation-status-change',
  CONVERSATION_MEMBER_JOIN: 'conversation-member-join',
  CONVERSATION_MEMBER_LEAVE: 'conversation-member-leave',
  CONVERSATION_READ: 'conversation-read',
  CONVERSATION_STAR: 'conversation-star',
  CONVERSATION_ARCHIVE: 'conversation-archive',
  CONVERSATION_VISITOR_READ: 'conversation-visitor-read',
  CONVERSATION_VISITOR_DELIVERED: 'conversation-visitor-delivered',
  APPUSER_AVAILABLE: 'appuser-available',
  TAKE_CONVERSATION: 'take-conversation',
  CANCEL_TAKE_CONVERSATION: 'cancel-take-conversation',
  MESSAGE_UPDATE: 'message-update',
  ONLINE_CONVERSATION_COUNT_UPDATE: 'online-conversations-count-update',
};

export const UPDATE_CONVERSATION_LIST_TYPE = {
  KNOWN_USER: 'knownUser',
  UPDATE_LAST_MESSAGE: 'updateLastMessage',
  ARCHIVE: 'archive',
  STAR: 'star',
  READ: 'read',
  STATUS: 'status',
  STATUS_CHANGE: 'statusChange',
  VISITOR_BLOCKED: 'visitorBlocked',
  UPDATE_UPLOAD_PROGRESS: 'updateUploadProgress',
};

export const CHAT_CONSTANT = {
  STATUS: {
    ALL_CONVERSATIONS: 'All Conversations',
    OPEN: 'Open',
    PENDING: 'Pending',
    CLOSE: 'Close',
    ONLINE: 'Online',
    ARCHIVED: 'Archived',
    STARRED: 'Starred',
    UNREAD: 'Unread',
    MY: 'My Conversations',
  },
  RESOLVE_STATUS: {
    'All Conversations': 'ALL_CONVERSATIONS',
    Open: 'OPEN',
    Pending: 'PENDING',
    Close: 'CLOSE',
    Online: 'ONLINE',
    Archived: 'ARCHIVED',
    Starred: 'STARRED',
    Unread: 'UNREAD',
    'My Conversations': 'MY',
  },
  SORT: {
    NEWEST_CONVERSATION: 'Newest Conversation',
    OLDEST_CONVERSATION: 'Oldest Conversation',
  },
  STATUS_COLOR: {
    ALL_CONVERSATION: '#556cd6',
    OPEN: '#1084fe',
    PENDING: '#3e2723',
    CLOSED: '#808080',
    ONLINE: '#02C8A7',
    ARCHIVED: '#4a148c',
    STARRED: '#dd2c00',
    UNREAD: '#1a237e',
    MY: '#1b5e20',
  },
};

export const CONVERSATION_LIST_TYPES = {
  BOT: 'bot',
  NON_BOT: 'nonBot',
  ME: 'me',
};

export const CONVERSATION_MESSAGE_TYPES = {
  MESSAGE: 'message',
  INFO: 'info',
  CSAT: 'feedback',
  CSAT_RESPONSE: 'csat_response',
  CSAT_CANCEL: 'csat_cancel',
  VISITOR_BLOCKED: 'visitor_blocked',
  ATTACHMENTS: 'attachments',
};

export const ratingsOption = {
  1: { emoji: disappointingEmoji, name: 'Disappointing' },
  2: { emoji: badEmoji, name: 'Bad' },
  3: { emoji: justokEmoji, name: 'Just ok' },
  4: { emoji: goodEmoji, name: 'Good' },
  5: { emoji: excellentEmoji, name: 'Excellent' },
};

export const ABV_VISITOR_FIELDS = [
  'email',
  'firstName',
  'lastName',
  'company',
  'phone',
  'location',
  'city',
  'region',
  'country',
  'job',
];

export const ABV_VISITOR_FIELDS_TITLE = {
  email: 'Email',
  firstName: 'First name',
  lastName: 'Last name',
  company: 'Company',
  phone: 'Phone',
  city: 'City',
  region: 'Region',
  country: 'Country',
  job: 'Job title',
};

export const NOTIFICATION = {
  TYPE: {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
  },
  VARIANTS: {
    DEFAULT: 'default',
    AGENT_REQUEST: 'agentRequest',
  },
};

export const BLOCKED_TAG = {
  tagId: '4AF5dc081b1f08d0a8fac627',
  tagName: 'Blocked',
};
